<template>
    <div class="pa-2 d-flex flex-column align-center justify-center hv-100">

        <v-card width="400px">
            <v-card-title>
                Iniciar sesión
            </v-card-title>

            <v-card-text>
                <v-text-field
                    variant="outlined"
                    density="compact"
                    label="Usuario"
                    type="email"
                    name="email"
                    prepend-inner-icon="mdi-account"
                    v-model="username"
                />
                <v-text-field
                    variant="outlined"
                    density="compact"
                    label="Contraseña"
                    type="password"
                    name="password"
                    prepend-inner-icon="mdi-lock"
                    v-model="password"
                    @keyup.enter="login"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    variant="tonal"
                    block
                    color="primary"
                    @click="login"
                    :disabled="!username || !password"
                >
                    Iniciar sesión
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script lang="ts" setup>
import { AuthService } from '@/services/auth/authService';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';

const router = useRouter();
const authService = new AuthService();

const username = ref('');
const password = ref('');

const toast = useToast();

async function login() {
    const response = await authService.login(username.value, password.value);
    
    if (response?.accessToken) {
        localStorage.setItem('accessToken', response.accessToken);

        router.push({ name: 'home' });
        toast.success("Inicio de sesión correcto");
        return
    }

    toast.error("Usuario o contraseña incorrectos");
}

onMounted(() => {
    localStorage.removeItem('accessToken');
})
</script>

<style lang="scss" scoped>
.hv-100 {
    height: 100vh;
}
</style>